var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-root"},[_c('div',{staticClass:"d-flex flex-row-fluid flex-column bgi-size-cover bgi-position-center bgi-no-repeat p-10 p-sm-30",style:({
      backgroundImage: `url(${_vm.backgroundImage})`,
    })},[_c('h3',{staticClass:"font-size-sm-100 font-weight-boldest text-dark-75 mt-15",staticStyle:{"font-size":"150px"}},[_vm._v(" Sukses ")]),_c('p',{staticClass:"font-size-h3 font-weight-light"},[_vm._v(" Pembayaran anda telah kami terima ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }